export default __webpack_public_path__ + "static/media/12.80f84e61.svg";